import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const TABS = [
    { to: "/app/settings/branding", label: "Organization Branding" },
    { to: "/app/settings/users", label: "Users & Roles" },
    { to: "/app/settings/subscription", label: "Subscription" },
    { to: "/app/settings/integrations", label: "Integrations" },
    { to: "/app/settings/profile", label: "Profile" },
];

export function SettingsShell({ children, title, subtitle, extraTabs = [] }) {
    const allTabs = [...TABS, ...extraTabs];
    return (
        <div className="p-6 md:p-10" data-testid="settings-shell">
            <div className="max-w-6xl">
                <div className="overline">Settings</div>
                <h1 className="mt-3 font-display text-4xl tracking-tight leading-none">{title}</h1>
                {subtitle && <p className="mt-3 text-sm text-muted-foreground max-w-2xl">{subtitle}</p>}
                <nav className="mt-8 flex flex-wrap gap-1 border-b border-border" data-testid="settings-tabs">
                    {allTabs.map((t) => (
                        <NavLink
                            key={t.to}
                            to={t.to}
                            data-testid={`settings-tab-${t.label.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and')}`}
                            className={({ isActive }) =>
                                `px-4 py-3 text-sm border-b-2 -mb-px ${isActive ? "border-foreground text-foreground" : "border-transparent text-muted-foreground hover:text-foreground"}`
                            }
                        >
                            {t.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="mt-8">{children}</div>
            </div>
        </div>
    );
}
